import type {ReactElement} from 'react';
import {useState} from 'react';
import type {GridItemProps} from '../grid-item';
import type {GridMediaItemStorage} from '../grid-media-item';
import {GridMediaItem} from '../grid-media-item';
import styles from './grid-shape-item.module.scss';

export interface GridShapeItemStorage extends GridMediaItemStorage {
  hashedFilename: string;
}

export interface GridShapeItemBackEndData {
  id: string;
  isHidden: boolean;
}

interface GridShapeItemProps extends GridItemProps {
  thumbSrc: string;
}

export function GridShapeItem({...props}: GridShapeItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      thumb={
        <img
          onLoad={(): void => {
            setIsImageLoaded(true);
          }}
          className={styles.thumb}
          src={props.thumbSrc}
          alt={window.i18next.t('pmwjs_image')}
          draggable="false"
          loading="lazy"
        />
      }
    />
  );
}
